import { useParams, Navigate } from "react-router-dom";

import { InvoiceBusiness } from "./InvoiceBusiness";
import { ROUTES } from "../../routes";
import { useGetInvoicePublicQuery } from "../../store/services/invoices";

export const InvoiceBusinessPage: React.FC = () => {
  const { id = "" } = useParams();
  const { data } = useGetInvoicePublicQuery({ id });

  if (!id) {
    return <Navigate to={ROUTES.NOT_FOUND} />;
  }

  if (!data) {
    return <></>;
  }

  return data && <InvoiceBusiness data={data} />;
};
